(function () {
  'use strict';

  function applyStoreListLayout(items) {
    items.forEach(function (item) {
      item.style.setProperty('background-size', '100px 80px', 'important');
      item.style.setProperty('background-position', 'left center', 'important');
      item.style.setProperty('background-repeat', 'no-repeat', 'important');
      item.style.setProperty('padding-top', '10px', 'important');
      item.style.setProperty('padding-bottom', '10px', 'important');
      item.style.setProperty('padding-left', '116px', 'important');
      item.style.setProperty('min-height', '80px', 'important');
      item.style.setProperty('display', 'flex', 'important');
      item.style.setProperty('flex-direction', 'column', 'important');
      item.style.setProperty('justify-content', 'center', 'important');
    });
  }

  function run() {
    var items = document.querySelectorAll('.progus-store-locator-store-list-element');
    if (items.length > 0) applyStoreListLayout(items);
  }

  // document.body を常に監視（Store Locatorが動的に生成するため）
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('progus-store-locator-store-list-element')) {
          applyStoreListLayout([node]);
        }
        var children = node.querySelectorAll
          ? node.querySelectorAll('.progus-store-locator-store-list-element')
          : [];
        if (children.length > 0) applyStoreListLayout(children);
      });
    });
  });

  // DOM構築完了後に body を監視開始 + 既存要素に即時適用
  function init() {
    run();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
